import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useToggleViewVisibilityMenuOption } from "./hooks/useToggleViewVisibilityMenuOption";
import { useToggleViewVisibilityMenuOptions } from "./hooks/useToggleViewVisibilityMenuOptions";
import { ViewVisibilityHeaderToggle } from "./shared/ViewVisibilityHeaderToggle";
import { ViewVisibilitySection } from "./ViewVisibilitySection/ViewVisibilitySection";
import { ViewVisibilityToggle } from "./ViewVisibilitySection/ViewVisibilityToggle";
export const ConfigViewVisbilityOptions = /*#__PURE__*/ memo((param)=>{
    let { options } = param;
    const { toggleViewVisibilityMenuOption } = useToggleViewVisibilityMenuOption();
    const { toggleViewVisibilityMenuOptions } = useToggleViewVisibilityMenuOptions();
    const initialShowOptions = options.some((param)=>{
        let { isVisible } = param;
        return isVisible;
    });
    if (options.length === 1) {
        const option = options[0];
        return /*#__PURE__*/ _jsx(ViewVisibilityHeaderToggle, {
            id: option.fieldName,
            label: option.label,
            onToggle: ()=>toggleViewVisibilityMenuOption(option),
            isToggleOn: option.isVisible
        }, option.fieldName);
    }
    return /*#__PURE__*/ _jsx(ViewVisibilitySection, {
        initialShowOptions: initialShowOptions,
        id: "info",
        label: "Metadata",
        onToggleShowingOptions: (showing)=>{
            toggleViewVisibilityMenuOptions(options, showing);
        },
        toggles: options.map((option)=>/*#__PURE__*/ _jsx(ViewVisibilityToggle, {
                onClick: ()=>toggleViewVisibilityMenuOption(option),
                option: option
            }, option.fieldName))
    });
});
ConfigViewVisbilityOptions.displayName = "ConfigViewVisbilityOptions";
